<div class="mt-s p-s row align-items-center">
    <img src="../../assets/img/icons/tiles/schloss.svg" alt="Euro sign icon">
    <div class="col-9">
      <span>Dieser Bereich ist für Ihr Benutzerkonto nicht freigegeben. Bitte wenden Sie sich an den/die Inhaber/in,
        um die Zugriffsberechtigung zu erhalten.</span><br>
        <p>Sie werden in {{seconds}} Sekunden zum Dashboard weitergeleitet.</p>
    </div>

</div>